import { NAME } from './constants';

export const CHANGE_VIEW = `${NAME}/CHANGE_VIEW`;
export const RETURN_TO_PREVIOUS_VIEW = `${NAME}/RETURN_TO_PREVIOUS_VIEW`;
